/* Stylesheet */

.forbidden_container {
  color: var(--ion-color-text-primary);
}
